import { Component, Input } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-bannertextwithimage2',
  templateUrl: './bannertextwithimage2.component.html',
  styleUrls: ['./bannertextwithimage2.component.scss']
})
export class Bannertextwithimage2Component {

    @Input() item: any;
    @Input() img: any;
    @Input() data : any;
    @Input() categoryId6: any;
  
    @Input() navigation: any;
    @Input() catId: any;
  
    @Input() navigatedUrl: any;
  
    public serverPath = environment.commonImageApi + '/home/';
  
    public serverPath1 = environment.commonImageApi + '/commonSlider/';
    
    constructor( private commonService: CommonService,) { }
  
    goToCategories(id: any) {
      if(id>0){
        this.commonService.goToCategory(1, parseInt(id));
      }
  
    }
    
  
    link(url: any) {
  
      this.commonService.goToLink(url)
    }
  
    openInNewWindow(url: string) {
      if (url) {
        const fullURL = this.prependProtocol(url);
        this.commonService.goToLink(url)
      }
    }
  
    prependProtocol(url: string): string {
      if (!url.includes('http://') && !url.includes('https://')) {
        return 'https://' + url;
      }
      return url;
    }
  


  // isWhiteBackground(color: string): boolean {
  //   if (!color) return false;

  //   const normalized = color.trim().toLowerCase();

  //   return (
  //     normalized === 'white' ||
  //     normalized === '#fff' ||
  //     normalized === '#ffffff' ||
  //     normalized === 'rgb(255,255,255)'
  //   );

  // }

  isWhiteBackground(color: string): boolean {
    if (!color) return false;

    const normalized = color.trim().toLowerCase();

    // If the color is a gradient, default to dark background (use white text)
    if (normalized.includes('gradient')) {
      return false;
    }

    // Check for solid white
    if (
      normalized === 'white' ||
      normalized === '#fff' ||
      normalized === '#ffffff' ||
      normalized === 'rgb(255,255,255)'
    ) {
      return true;
    }

    // If hex color, calculate brightness
    if (normalized.startsWith('#') && (normalized.length === 7 || normalized.length === 4)) {
      let r: number, g: number, b: number;

      if (normalized.length === 7) {
        r = parseInt(normalized.slice(1, 3), 16);
        g = parseInt(normalized.slice(3, 5), 16);
        b = parseInt(normalized.slice(5, 7), 16);
      } else {
        // short hex e.g. #fff
        r = parseInt(normalized[1] + normalized[1], 16);
        g = parseInt(normalized[2] + normalized[2], 16);
        b = parseInt(normalized[3] + normalized[3], 16);
      }

      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness > 200; // light background
    }

    return false;
  }

  /**
   * Returns a valid background string, supporting solid or gradient colors.
   * You can also use hoverState if needed.
   */
  getDynamicBackground(color: string, hover: boolean = false): string {
    if (!color) return '';

    // If the color is already a gradient, return as-is
    if (color.includes('gradient')) {
      return color;
    }

    // If solid color, apply gradient effect if needed
    if (hover) {
      return `linear-gradient(90deg, ${color} 50%, ${color} 50%)`;
    } else {
      return `linear-gradient(270deg, #FFFFFF 50%, ${color} 38%)`;
    }
  }

  
}
